import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import MarketingCampaignService from "services/crm/marketingCampaignService";

export const searchCallHistory = createAsyncThunk(
  "mktCampaign/searchCallHistory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MarketingCampaignService.searchCallHistory(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const searchDetailCampaign = createAsyncThunk(
  "mktCampaign/searchDetailCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MarketingCampaignService.searchDetailCampaign(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const searchCampaign = createAsyncThunk(
  "mktCampaign/searchCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MarketingCampaignService.searchCampaign(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const exportCampaign = createAsyncThunk(
  "mktCampaign/exportCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await MarketingCampaignService.export(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getCampaignById = createAsyncThunk(
  "mktCampaign/getCampaignById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await MarketingCampaignService.getCampaignById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const addCampaign = createAsyncThunk(
  "mktCampaign/addCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await MarketingCampaignService.addCampaign(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateCampaign = createAsyncThunk(
  "mktCampaign/updateCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await MarketingCampaignService.updateCampaign(data);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteCampaign = createAsyncThunk(
  "mktCampaign/deleteCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await MarketingCampaignService.deleteCampain(id);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const copyCampain = createAsyncThunk(
  "mktCampaign/copyCampain",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await MarketingCampaignService.copyCampain(id);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const exportExcel = createAsyncThunk(
  "mktCampaign/exportExcel",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await MarketingCampaignService.export(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteOutboundCall = createAsyncThunk(
  "mktCampaign/deleteOutboundCall",
  async (payload, { rejectWithValue }) => {
    try {
      const { data, onSuccess } = payload;
      const response = await MarketingCampaignService.deleteOutboundCall(data);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const reCall = createAsyncThunk(
  "mktCampaign/reCall",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await MarketingCampaignService.reCall(id);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const reCalls = createAsyncThunk(
  "mktCampaign/reCalls",
  async (data, { rejectWithValue }) => {
    try {
      const { payload, onSuccess } = data;
      const response = await MarketingCampaignService.reCalls(payload);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateCampaignStatus = createAsyncThunk(
  "mktCampaign/updateCampaignStatus",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await MarketingCampaignService.updateCampaignStatus(payload);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateDetailChamSoc = createAsyncThunk(
  "mktCampaign/updateDetailChamSoc",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await MarketingCampaignService.updateDetailChamSoc(payload);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const kqSearch = createAsyncThunk(
  "mktCampaign/kqSearch",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MarketingCampaignService.kqSearch(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const kqUpsert = createAsyncThunk(
  "mktCampaign/kqUpsert",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await MarketingCampaignService.kqUpsert(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const kqDelete = createAsyncThunk(
  "mktCampaign/kqDelete",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await MarketingCampaignService.kqDelete(id);
      if (onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  campaignList: [],
  campaignDetail: {},
  callHistoryData: {},
  detailCampaignData: [],
  kqList: [],
  kqMap: {},
};

export const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      // search call history
      .addCase(searchCallHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchCallHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.callHistoryData = action.payload;
      })
      .addCase(searchCallHistory.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(searchDetailCampaign.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchDetailCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.detailCampaignData = action.payload;
      })
      .addCase(searchDetailCampaign.rejected, (state, action) => {
        state.loading = false;
      })
      // search
      .addCase(searchCampaign.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.campaignList = action.payload;
      })
      .addCase(searchCampaign.rejected, (state, action) => {
        state.loading = false;
      })
      // add new campaign
      .addCase(addCampaign.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCampaign.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addCampaign.rejected, (state, action) => {
        state.loading = false;
      })

      // add new campaign
      .addCase(updateCampaign.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCampaign.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCampaign.rejected, (state, action) => {
        state.loading = false;
      })

      // get campaign by id
      .addCase(getCampaignById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaignById.fulfilled, (state, action) => {
        state.loading = false;
        state.campaignDetail = action.payload;
      })
      .addCase(getCampaignById.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(exportExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportExcel.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportExcel.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateCampaignStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCampaignStatus.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateCampaignStatus.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateDetailChamSoc.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDetailChamSoc.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateDetailChamSoc.rejected, (state) => {
        state.loading = false;
      })

      .addCase(kqSearch.pending, (state) => {
        state.loading = true;
      })
      .addCase(kqSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.kqList = action.payload;
        const detailId = action.meta.arg?.campaignDetailId;
        const data = Array.isArray(action.payload) ? action.payload : [];
        if (detailId) {
          state.kqMap = { ...state.kqMap, [detailId]: data };
        } else {
          const map = {};
          data.forEach((kq) => {
            const key = kq.campaignDetailId;
            if (!map[key]) map[key] = [];
            map[key].push(kq);
          });
          state.kqMap = map;
        }
      })
      .addCase(kqSearch.rejected, (state) => {
        state.loading = false;
      })

      .addCase(kqUpsert.pending, (state) => {
        state.loading = true;
      })
      .addCase(kqUpsert.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(kqUpsert.rejected, (state) => {
        state.loading = false;
      })

      .addCase(kqDelete.pending, (state) => {
        state.loading = true;
      })
      .addCase(kqDelete.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(kqDelete.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = campaignSlice.actions;

export default campaignSlice.reducer;
